import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../../notes/icon/icon.module';
import { TextWithIconComponent } from './text-with-icon.component';

@NgModule({
  declarations: [TextWithIconComponent],
  imports: [CommonModule, IconModule],
  exports: [TextWithIconComponent],
})
export class TextWithIconModule {}
